export type CommandType = {
  name: string;
  type: 'link' | 'advancedLink' | 'advancedSearch';
  path: string;
};

export const commands: CommandType[] = [
  {
    name: 'dashboard',
    type: 'link',
    path: '/dashboard',
  },
  {
    name: 'new order',
    type: 'link',
    path: '/new-order',
  },
  {
    name: 'orders',
    type: 'link',
    path: '/orders',
  },
  {
    name: 'order',
    type: 'advancedLink',
    path: '/orders/:id',
  },
  {
    name: 'phone',
    type: 'advancedSearch',
    path: '/orders?q=',
  },
  {
    name: '1881',
    type: 'advancedLink',
    path: '/1881/:id',
  },
  {
    name: 'shift',
    type: 'link',
    path: '/shift',
  },
  {
    name: 'planner/print list',
    type: 'link',
    path: '/planner/print-list',
  },
  {
    name: 'planner map',
    type: 'link',
    path: '/planner-map',
  },
  {
    name: 'monitor',
    type: 'link',
    path: '/monitor',
  },
  {
    name: 'monitor/completed',
    type: 'link',
    path: '/monitor/completed',
  },
  {
    name: 'monitor/couriers',
    type: 'link',
    path: '/monitor/couriers',
  },
  {
    name: 'monitor/bundles',
    type: 'link',
    path: '/monitor/bundles',
  },
  {
    name: 'monitor/sort list',
    type: 'link',
    path: '/monitor/sort-list',
  },
  {
    name: 'hub',
    type: 'link',
    path: '/hub',
  },
  {
    name: 'warehouse',
    type: 'link',
    path: '/warehouse',
  },
  {
    name: '/bundles/:bundleId',
    type: 'advancedLink',
    path: '/bundles/:bundleId',
  },
  {
    name: 'reports',
    type: 'link',
    path: '/reports',
  },
  {
    name: 'reports/volumes',
    type: 'link',
    path: '/reports/volumes',
  },
  {
    name: 'reports/courier',
    type: 'link',
    path: '/reports/courier',
  },
  {
    name: 'reports/scanning',
    type: 'link',
    path: '/reports/scanning',
  },
  {
    name: 'reports/driving',
    type: 'link',
    path: '/reports/driving',
  },
  {
    name: 'booking',
    type: 'link',
    path: '/booking',
  },
  {
    name: 'reports/invoiceCourier',
    type: 'link',
    path: '/reports/invoiceCourier',
  },
  {
    name: 'reports/invoiceCourier2',
    type: 'link',
    path: '/reports/invoiceCourier2',
  },
  {
    name: ' reports/invoiceCourierCompany',
    type: 'link',
    path: '/reports/invoiceCourierCompany',
  },
  {
    name: 'reports/cost',
    type: 'link',
    path: '/reports/cost',
  },
  {
    name: 'reports/prediction',
    type: 'link',
    path: '/reports/prediction',
  },
  {
    name: 'users/create',
    type: 'link',
    path: '/users/create',
  },
  {
    name: 'users',
    type: 'link',
    path: '/users',
  },
  {
    name: 'dashboard/capacity-info',
    type: 'link',
    path: '/dashboard/capacity-info',
  },
  {
    name: 'tools/address-fix',
    type: 'link',
    path: '/tools/address-fix',
  },
  {
    name: 'monitor/hub-bundles',
    type: 'link',
    path: '/monitor/hub-bundles',
  },
];
